import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stiphtml'
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: any): any {
        if ((value === null) || (value === '')) {
            return '';
        }

        const elem = document.createElement('div');
        elem.innerHTML = value;
        return elem.innerText;
    }
}



// WEBPACK FOOTER //
// ./src/vas/pipes/strip-html.pipe.ts